window.$ = window.jQuery

// Load front end styles
import './frontend.less'

// AOS animation lib: https://github.com/michalsnik/aos/tree/v2
import AOS from 'aos'
$(window).on("load", function () {
    AOS.init({
        once: true,
        disable: window.innerWidth <= 960
    })
});

// Vue Library
import { createApp } from 'vue'
const app = createApp({
    el: '.siteWrapper'
})

// Global functions
require('../../../chop/js/functions.js')

// Plugins
require('../../../chop/js/plugins/mobile_menu.js')
require('../../js/plugins/mtc_homepage_hero_video.js')

// Parent script file
require('../../js/script.js')
require('../../js/plugins/mtc_jquery_parallax_scroll.js')

// MtcWPMLLanguageSelector assets
app.component(
    'language-selector',
    require('../../js/components/language_selector.vue').default
)

// testimonials slider
app.component(
    'testimonials-slider',
    require('../../js/components/testimonials_slider.vue').default
)

// case study slider
app.component(
    'case-study-slider',
    require('../../js/components/case_study_slider.vue').default
)

// news slider
app.component(
    'news-slider',
    require('../../js/components/news_slider.vue').default
)

// image slider
app.component(
    'image-slider',
    require('../../js/components/image_slider.vue').default
)

// article listing
app.component(
    'article-listing-layout',
    require('../../js/components/article_listing_layout.vue').default
)

// employee listing
app.component(
    'employee-listing',
    require('../../js/components/employee_listing.vue').default
)

window.addEventListener('DOMContentLoaded',function () {
    const site_wrapper = document.getElementsByClassName('siteWrapper')[0]
    const script_tags = [...site_wrapper.getElementsByTagName('script')]
    const style_tags = [...site_wrapper.getElementsByTagName('style')]

    script_tags.concat(style_tags).forEach(tag => {
        document.body.append(tag)
    })

    app.mount('.siteWrapper')
})
